import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import Datatable from "../../../core/common/dataTable/index";
import { ColumnsType } from "antd/es/table";
import {
  parseNumber,
  safeLocaleCompare,
} from "../../../core/methods/sorterMethods";
import useApi from "../../../core/customhook/useApi";
import { useNavigate } from "react-router";
import Loading from "../../../core/common/custom-loading/Loading";
import { getSearchableHeader } from "../../../core/utils/getSearchableHeader";
import { exportAntdTableToExcel } from "../../../core/utils/exportExcel";
import { cellWidth } from "../../../core/methods/tableCellWidth";

// breadcrumb data
const breadcrumbItem = [{ label: "Manage Verifier" }];

const Manager_ManageVerifier = () => {
  const navigate = useNavigate();
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});

  type InviteItem = any;
  const filteredData = (Array.isArray(allItemList) ? allItemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );
  const manageVerifier = useApi<any>(
    "/api/v1/agency/agency-manager-verifyer-members",
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const fetchVerifierList = async () => {
    try {
      const res = await manageVerifier.callApi();

      if (!res?.success) {
        setAllItemList([]);
        return;
      }

      const rows = res?.data?.rows ?? [];

      setAllItemList(
        rows.map((item: any, index: number) => ({
          ...item,
          sno: index + 1,
        })),
      );
    } catch (error) {
      console.error(error);
      setAllItemList([]);
    }
  };

  useEffect(() => {
    fetchVerifierList();
  }, []);

  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Manager Name",
        "manager_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "manager_name",
      render: (text: string) => <div className="text-capitalize">{text}</div>,
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_name"),
    },
    {
      title: getSearchableHeader(
        "Manager Email",
        "manager_email",
        setInventoryColumnSearch,
      ),
      dataIndex: "manager_email",
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "manager_email"),
    },
    {
      title: getSearchableHeader(
        "Manager Contact",
        "member_phone",
        setInventoryColumnSearch,
      ),
      dataIndex: "member_phone",
      sorter: (a: any, b: any) =>
        parseNumber(a.member_phone) - parseNumber(b.member_phone),
    },
    {
      title: getSearchableHeader(
        "Verifier Name",
        "member_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "member_name",
      render: (text: string) => <div className="text-capitalize">{text}</div>,
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "member_name"),
    },
    {
      title: getSearchableHeader(
        "Verifier Email",
        "member_email",
        setInventoryColumnSearch,
      ),
      dataIndex: "member_email",
      sorter: (a: any, b: any) => safeLocaleCompare(a, b, "member_email"),
    },
    {
      title: getSearchableHeader(
        "Verifier Contact",
        "member_phone",
        setInventoryColumnSearch,
      ),
      dataIndex: "member_phone",
      sorter: (a: any, b: any) =>
        parseNumber(a.member_phone) - parseNumber(b.member_phone),
    },
    {
      title: "Cases",
      align: "center",
      width: 100,
      render: (_: any, record: any) => (
        <button
          type="button"
          className="btn btn-sm btn-tertiary py-0"
          onClick={() =>
            navigate(all_routes.manager_verifier_cases, {
              state: {
                verifier: record,
              },
            })
          }
        >
          <i className="ti ti-eye"></i>
        </button>
      ),
    },
  ];

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "Manage_Verifier_Report",
      sheetName: "Manage Verifier",
    });
  };

  const loading = manageVerifier.loading;

  return (
    <div>
      <>
        <div className="page-wrapper">
          <div className="content">
            <PageBreadcrumb
              title="Manage Verifier"
              breadcrumbs={breadcrumbItem}
            />
            {/* Table */}

            <div className="card mt-4">
              {manageVerifier.loading ? (
                <Loading />
              ) : (
                <>
                  <div className="d-flex justify-content-end pe-2 py-2 pb-0">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={handleDownloadExcel}
                      disabled={loading}
                    >
                      <i className="ti ti-download" /> Export to Excel
                    </button>
                  </div>
                  <Datatable
                    columns={columns}
                    dataSource={filteredData}
                    rowKey="member_id"
                    Selection={false}
                    fixedHeader
                    tableHeight={650}
                  />
                </>
              )}
            </div>

            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="datatable-paginate mt-4" />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Manager_ManageVerifier;
